<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter v-if="!hideFilters">
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="mt-5 mx-3">
            </SupplierSelect>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getFilteredSupplierFailureCodes" :optional-filters="filters"
          :lockedFilters="lockedFilters" :paginationEnabled="true" :show-filter-tab="!hideFilters"
          :show-sorting-tab="false" :itemsPerPage="100" :dialog-trigger="dialogtrigger" :dialogItem="editItem"
          :dialog-method-config="dialogMethodConfig" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)" />
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <SupplierSelect v-model="item.SupplierId" allowCreate
                    :externaledit="!lockedFilters || !lockedFilters.SupplierIdList"
                    :disabled="!!lockedFilters && !!lockedFilters.SupplierIdList">
                  </SupplierSelect>
                </v-col>
                <v-col cols="12" class="my-3">
                  <QTextField v-model="item.Code" :label="$t('servicesystem.common_objects.commonterms.code')"
                    maxlength="50" :rules="[requiredRule]" externaledit>
                  </QTextField>
                </v-col>
                <v-col cols="12">
                  <QTextField v-model="item.Description" :label="$t('servicesystem.common_objects.order.description')"
                    maxlength="200" :rules="[requiredRule]" externaledit>
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/SupplierFailureCodeListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminFailureCodes",
  props: {
    pk: {
      type: String,
      default: "FC-",
    },
    hideFilters: Boolean,
    lockedFilters: Object,
  },
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
    SupplierSelect,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      supplierlist: [],
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createSupplierFailureCode',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeSupplierFailureCode',
        },
      },
    };
  },

  mounted() {
    this.getSuppliers();
  },

  methods: {
    getSuppliers() {
      clientAPI.methods.getSupplierList()
        .catch((e) => console.error(e))
        .then((response) => {
          //console.log("supplier list", response);
          this.supplierlist = response;
        });
    },

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },

    newEditItem() {
      var supplierId =
        this.lockedFilters?.SupplierIdList?.[0]
        ?? this.suppliersfilter?.[0]
        ?? null;
      if (supplierId) { supplierId = parseInt(supplierId); }
      var obj = { Id: null, Code: "", Description: "", SupplierId: supplierId };
      //console.log("newEditItem", obj);
      this.setEditItem(obj);
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          SupplierIdList: this.suppliersfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.newEditItem(); }
  },
};
</script>